import { useLocation, useNavigate, useParams } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import { TECHNIQUE_SOURCE, techniqueById } from '../techniques';

/**
 * Full-page explanation of one intensity technique.
 *
 * A page rather than a modal: the app uses no dialogs, and several paragraphs
 * of reading is exactly what a full screen is for. Back returns to whichever
 * screen the info button was tapped on.
 */
export default function TechniquePage() {
  const { techniqueId } = useParams<{ techniqueId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = (location.state as { returnTo?: string } | null)?.returnTo ?? '/';

  const technique = techniqueById(techniqueId);

  if (!technique) {
    return (
      <>
        <SiteHeader back={{ label: 'Back', onClick: () => navigate(returnTo) }} />
        <main className="page page--narrow">
          <p className="muted">No explanation for that technique.</p>
        </main>
      </>
    );
  }

  return (
    <>
      <SiteHeader back={{ label: 'Back', onClick: () => navigate(returnTo) }} />
      <main className="page page--narrow">
        <p className="muted">Intensity technique</p>
        <h1>{technique.title}</h1>
        <p className="technique-summary">{technique.summary}</p>

        {technique.body.map((para, i) => (
          <p key={i} className="technique-para">{para}</p>
        ))}

        {technique.steps && (
          <section className="technique-steps">
            <h2>How it works</h2>
            <ol>
              {technique.steps.map((step, i) => <li key={i}>{step}</li>)}
            </ol>
          </section>
        )}

        {technique.note && (
          <section className="notes-panel" style={{ marginTop: 18 }}>
            <h3>Important</h3>
            <p>{technique.note}</p>
          </section>
        )}

        <p className="technique-source">From {TECHNIQUE_SOURCE}.</p>

        <button
          type="button"
          className="btn-primary btn-block btn-lg"
          style={{ marginTop: 20 }}
          onClick={() => navigate(returnTo)}
        >
          Back to your workout
        </button>
      </main>
    </>
  );
}
